import React from 'react';
import { authRoles } from '../../store/auth';

const ProfileConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: true,
        },
      },
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: '/profile',
      component: React.lazy(() => import('./Profile')),
    },
  ],
};

export default ProfileConfig;
